"use client";

import { type ReactElement } from "react";
import { usePathname } from "next/navigation";
import ParticleSystem from "@/components/particles/ParticleSystem";

/**
 * Same palette as the home hero simplex field (cyan–teal + brand sparks), omitted on `/`.
 * Transparent canvas over the layout navy; main uses a light scrim in dark mode for text contrast.
 */
export function ConditionalParticleBackground(): ReactElement | null {
  const pathname = usePathname();
  if (pathname === "/") return null;

  return (
    <div className="pointer-events-none fixed inset-0 z-0 opacity-[0.3]" aria-hidden>
      <ParticleSystem
        className="absolute inset-0 h-full w-full"
        particlePalette="hero"
        transparentBackground
      >
        <div className="min-h-screen w-full" />
      </ParticleSystem>
    </div>
  );
}
